export default class ScrollToLazy {

	constructor(node, modules, options) {
		this.node = node;
		this.modules = modules;
		this.options = options;
		this.init();
	}

	init() {
		this.setup();
		this.findTarget();
		this.addListener();
	}

	setup() {
		// default selectors
		this.selectors = {
			buttonAttr: 'data-scrollto-button',
			targetAttr: 'data-scrollto-target'
		}
		// default settings
		this.settings = {
			offset: 20
		}
		// assign custom selectors
		if (this.options.selectors) { 
			this.selectors = Object.assign(this.selectors, this.options.selectors);
		}
		// assign custom settings
		if (this.options.settings) { 
			this.settings = Object.assign(this.settings, this.options.settings);
		}
	}

	findTarget() {
		if(!this.modules) return;
		const id = this.node.getAttribute(this.selectors.buttonAttr);
		const area = this.modules.find(x => {
			return x.node.getAttribute(this.selectors.targetAttr) === id
		})
		this.area = area;
	}

	addListener() {
		this.node.addEventListener('click', this.handleClick.bind(this));
	}

	handleClick(e) {
		e.preventDefault();
		if(!this.modules) return;
		let modulesToLoad = this.modules.filter(x => {
			return !x.intersected
		});
		let modulesLoading = modulesToLoad.map(x => {
			x.intersected = true;
			return x.loadModule();
		});
		Promise.all(modulesLoading).then(data => {
			window.scrollTo(0, this.area.node.offsetTop - this.settings.offset);
		})
	}
}